<template>
  <div class="event-button-new" @click="newEvent">
    新しいイベントの作成
  </div>
</template>

<script>
export default {
  methods: {
    newEvent: function () {
      this.$router.push('/event/new')
    }
  }
}
</script>

<style lang="scss" scoped>
.event-button-new {
  @include button-ol-primary;
}
</style>
